import type { FieldErrors } from "react-hook-form";
import type { VideoCarouselBannerInput } from "src/features/HomepageCarouselBanners/models";

import { FileUploadStep } from "src/features/vendorSponsorshipAdmin/components/FileUploadStep";
import { FormStep } from "src/features/vendorSponsorshipAdmin/components/FormStep";
import { RadioStep } from "src/features/vendorSponsorshipAdmin/components/RadioStep";
import { TextInputStep } from "src/features/vendorSponsorshipAdmin/components/TextInputStep";

export interface VideoCarouselBannerFormStepListProps {
	selectedVideo?: string | null;
	errors?: FieldErrors<VideoCarouselBannerInput>;
}

const VideoCarouselBannerFormStepList = ({
	selectedVideo,
	errors
}: VideoCarouselBannerFormStepListProps) => {
	return (
		<ul className="flex flex-col gap-4">
			<li className="w-full">
				<FormStep title="Banner name" error={errors?.name?.message}>
					<TextInputStep
						name="name"
						label="Banner name"
						placeholder="Banner name"
					/>
				</FormStep>
			</li>

			<li className="w-full">
				<FormStep
					title="Add video"
					subtitle="mp4 or mov"
					error={errors?.videoUuid?.message}
				>
					<FileUploadStep
						name="videoUuid"
						fileType="video"
						accept="video/mp4,video/quicktime"
						btnText={selectedVideo ? "Change video" : "Upload video"}
						btnVariant={selectedVideo ? "primary" : "primaryOutline"}
						btnColor={selectedVideo ? "white" : "black"}
					/>
				</FormStep>
			</li>

			<li className="w-full">
				<FormStep
					title="Banner text (Optional)"
					error={
						errors?.headingText?.message || errors?.subheadingText?.message
					}
				>
					<TextInputStep
						name="headingText"
						label="Heading (optional)"
						placeholder="Maximum heading count is 40 characters."
						maxLength={40}
					/>

					<TextInputStep
						name="subheadingText"
						label="Sub heading (optional)"
						placeholder="Maximum sub heading count 40 characters."
						maxLength={40}
					/>
				</FormStep>
			</li>
		</ul>
	);
};

export default VideoCarouselBannerFormStepList;
